import React from 'react';
import { List, useDynamicRowHeight } from 'react-window';
import { ActiveReviewNote } from '../shared';
import ActiveReviewNotesListRow, { ListState } from './active-review-notes-list-row';

type Props = {
    notes: ActiveReviewNote[];
};

const ActiveReviewNotesList = ({ notes }: Props) => {
    const rowHeight = useDynamicRowHeight({
        defaultRowHeight: 160,
    });

    return (
        <List
            rowComponent={ActiveReviewNotesListRow}
            rowCount={notes.length}
            rowHeight={rowHeight}
            rowProps={{
                listState: {
                    getNote: (index) => notes.at(index),
                } satisfies ListState,
            }}
        />
    );
};

export default ActiveReviewNotesList;
